import React, { Component } from 'react';
import { connect } from 'react-redux';
import l from 'services/logger';
import { getArrangement } from '../../store/actions/arrangements';
import Row50 from './Row50';
import Row100 from './Row100';
import { ActiveWardrobeContext } from '../../contexts/ActiveWardrobeContext';

const media = window.matchMedia('screen and (min-width:1025px)');
class MasonryTiles extends Component {
  state = {
    arrangementsList: [],
    constItems: {
      shopItem: {
        id: 'accessories-shop',
        link: '/buy-accessories',
        first_word: 'Dobierz',
        secound_word: 'akcesoria',
        images: `${process.env.PUBLIC_URL}/img/tiles/accessories.png`,
      },
      configurationStartItem: {
        id: 'start-configuration',
        link: '/height-settings',
        first_word: 'Otwórz',
        secound_word: 'konfigurator',
        images: `${process.env.PUBLIC_URL}/img/tiles/wardrobe.png`,
      },
    },
  };

  static contextType = ActiveWardrobeContext;

  componentDidMount() {
    if (media.matches) {
      this.prepareDesktopGrid();
    } else {
      this.mobile();
    }

    try {
      // Chrome & Firefox
      media.addEventListener('change', this.onChangeMediaQueries);
    } catch (e1) {
      try {
        // Safari
        media.addListener(this.onChangeMediaQueries);
      } catch (e2) {
        l.error(e2);
      }
    }
  }

  onChangeMediaQueries = e => {
    if (e.matches) {
      this.prepareDesktopGrid();
    } else {
      this.mobile();
    }
  };

  componentWillUnmount() {
    try {
      media.removeEventListener('change', this.onChangeMediaQueries);
    } catch (e) {
      try {
        media.removeListener(this.onChangeMediaQueries);
      } catch (e2) {
        l.error(e2);
      }
    }
  }

  mobile = () => {
    l.log('Wersja mobilna');

    const { constItems } = this.state;
    const { arrangements } = this.props;
    let arrangementsArray = [];
    const arrangementsList = [...arrangements];

    arrangementsArray.splice(0, 0, arrangementsList);
    arrangementsArray.splice(1, 0, constItems.shopItem);

    this.setState({
      arrangementsList: arrangementsArray,
    });
  };

  prepareDesktopGrid = () => {
    l.log('Wersja na desktopy');

    const { constItems } = this.state;
    const { arrangements } = this.props;

    let arrangementsArray = [];
    const arrangementsList = [...arrangements];

    arrangementsArray.splice(0, 0, constItems.configurationStartItem);
    arrangementsArray.splice(1, 0, arrangementsList);
    arrangementsArray.splice(2, 0, constItems.shopItem);

    this.setState({
      arrangementsList: arrangementsArray,
    });
  };

  openArrangement = id => {
    const { constItems } = this.state;
    const context = this.context;
    context.setActiveWardrobe(0);

    let excluded = Object.keys(constItems).map(item => constItems[item].id);
    if (excluded.indexOf(id) === -1) {
      this.props.getArrangement(id);
    }
  };

  render() {
    const { arrangementsList } = this.state;

    return (
      <div className="masonry masonry--with-top-margin ">
        {arrangementsList.map((item, index) => {
          if (Array.isArray(item)) {
            return (
              <div
                key={item[0].id}
                className="masonry__tile-wrapper"
                style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                <div className="title__box title__box-flex">
                  <span className="title title--first-word">WYBIERZ</span>
                  <span className="title title--secound-word">GOTOWY ZESTAW</span>
                </div>
                <Row100 item={item} openArrangement={this.openArrangement} />
              </div>
            );
          } else {
            return <Row50 item={item} key={item.id} openArrangement={this.openArrangement} />;
          }
        })}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    arrangement: state.arrangements.arrangement,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getArrangement: id => dispatch(getArrangement(id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MasonryTiles);
